package com.anjuros.website.components.language

var placeholderTextMap = mapOf(


    Regex("TEMPLATE\\d_SERVICE\\d?_DESC\\d?") to ResKey.PLACEHOLDER_SERVICE_TEXT,
    Regex("TEMPLATE\\d_SERVICE\\d?_TITLE\\d?") to ResKey.PLACEHOLDER_SERVICE_TITLE,
    Regex("TEMPLATE\\d_PRICE\\d_TITLE") to ResKey.PLACEHOLDER_SERVICE_TITLE,
    Regex("TEMPLATE\\d_SERVICE\\d+_TIME") to ResKey.PLACEHOLDER_SERVICE_TIME,
    Regex("TEMPLATE\\d_INFO_DESC\\d?") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d_INFO_TITLE\\d") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE\\d_ABOUT\\d?_TITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE\\d_INFO_START") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d_INFO_FOOTER") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_FAQ\\d+_Q") to ResKey.PLACEHOLDER_QUESTION,
    Regex("TEMPLATE\\d+_FAQ\\d+_A") to ResKey.PLACEHOLDER_ANSWER,
    Regex("TEMPLATE\\d+_SLOGAN") to ResKey.PLACEHOLDER_SLOGAN,
    Regex("TEMPLATE\\d+_REVIEW\\d+_TITLE") to ResKey.PLACEHOLDER_REVIEW_TITLE,
    Regex("TEMPLATE\\d+_REVIEW\\d+") to ResKey.PLACEHOLDER_REVIEW_DESC,
    Regex("TEMPLATE\\d+_REVIEW\\d+_NAME") to ResKey.PLACEHOLDER_REVIEW_NAME,
    Regex("TEMPLATE\\d+_REVIEWS_TEXT") to ResKey.PLACEHOLDER_ABOUT_TEXT,

    Regex("TEMPLATE\\d_ABOUT\\d?") to ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT,

    Regex("TEMPLATE\\d+_PRODUCT_SECTION\\d+") to ResKey.PLACEHOLDER_PRODUCT_TYPE,
    Regex("TEMPLATE\\d+_PRODUCT\\d+_TITLE") to ResKey.PLACEHOLDER_PRODUCT_TITLE,
    Regex("TEMPLATE\\d+_SECTION\\d+_PRODUCT\\d+_TITLE") to ResKey.PLACEHOLDER_PRODUCT_TITLE,
    Regex("TEMPLATE\\d+_SECTION\\d+_PRODUCT\\d+_DESC") to ResKey.PLACEHOLDER_PRODUCT_DESC,
    Regex("TEMPLATE\\d+_PRODUCT\\d+_DESC") to ResKey.PLACEHOLDER_PRODUCT_DESC,
    Regex("TEMPLATE\\d+_PRODUCTS_DESC") to ResKey.PLACEHOLDER_PRODUCT_DESC,

    Regex("TEMPLATE\\d+_SLOGAN\\d") to ResKey.PLACEHOLDER_SLOGAN,
    Regex("TEMPLATE\\d+_PRODUCTS_MAIN_TITLE") to ResKey.PLACEHOLDER_PRODUCTS_MAIN_TITLE,
    Regex("TEMPLATE\\d+_PROJECT\\d+_DESC") to ResKey.PLACEHOLDER_PROJECT_DESC,

    Regex("TEMPLATE\\d+_PROJECT\\d+_TITLE") to ResKey.PLACEHOLDER_PROJECT_TITLE,
    Regex("TEMPLATE\\d+_ACHIEVEMENT\\d+") to ResKey.PLACEHOLDER_ACHIEVEMENT,
    Regex("TEMPLATE\\d+_TIMETABLE\\d+_TITLE") to ResKey.PLACEHOLDER_TIMETABLE,
    Regex("^TEMPLATE\\d+_CONTACT_DROPDOWN\\d+\$") to ResKey.PLACEHOLDER_OPTION,
    Regex("^TEMPLATE\\d+_CONTACT_CHECKBOX\\d+\$") to ResKey.PLACEHOLDER_OPTION,
    Regex("^CONTACT_.+_LABEL\$") to ResKey.PLACEHOLDER_CONTACT_LABEL,
    Regex("CONTACT_.*\$") to ResKey.PLACEHOLDER_CONTACT_PLACEHOLDER,
    Regex("TEMPLATE\\d+_WHY_CHOOSE_TITLE") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_WHY_CHOOSE_SUBTITLE") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_WHY_CHOOSE_DESCRIPTION") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d+_EXPERIENCE_YEARS") to ResKey.PLACEHOLDER_EXPERIENCE,
    Regex("TEMPLATE\\d+_HERO_TITLE") to ResKey.PLACEHOLDER_SLOGAN,
    Regex("TEMPLATE\\d+_HERO_TITLE2") to ResKey.PLACEHOLDER_EMPTY,
    Regex("TEMPLATE\\d+_HERO_SUBTITLE") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_HERO_DESCRIPTION") to ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT2,
    Regex("TEMPLATE\\d+_HERO_BADGE\\d?") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_BADGE\\d") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_HERO_BADGE\\d+_DESC") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d+_REVIEWS_TITLE") to ResKey.PLACEHOLDER_REVIEWS_TITLE,
    Regex("TEMPLATE\\d+_REVIEWS_DESC") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d+_FAQ_CARD_DESCRIPTION") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d+_CONTACT_DESCRIPTION") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d+_FOOTER_DESCRIPTION") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d_CONTACT_CARD_SUBTITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE\\d_CONTACT_TITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE\\d_CONTACT_SUBTITLE\\d?") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d_CONTACT_CARD_TEXT") to ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT2,
    Regex("TEMPLATE\\d_CONTACT_CARD_TITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE\\d_CONTACT_CARD_FOOTER") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d_HERO_FEATURE\\d_TITLE") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d_HERO_FEATURE\\d_TEXT") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d_HERO_BUTTON_PRODUCTS") to ResKey.PLACEHOLDER_SECONDARY_BUTTON,
    Regex("TEMPLATE\\d_CATEGORY\\d_PRODUCT\\d_TITLE") to ResKey.PLACEHOLDER_PRODUCT_TITLE,
    Regex("TEMPLATE\\d_CATEGORY\\d_PRODUCT\\d_TEXT") to ResKey.PLACEHOLDER_PRODUCT_DESC,
    Regex("TEMPLATE\\d_CATEGORY\\d") to ResKey.PLACEHOLDER_PRODUCT_TYPE,
    Regex("TEMPLATE\\d_ABOUT_PARAGRAPH\\d?") to ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT2,
    Regex("TEMPLATE\\d+_WHY\\d+_TITLE") to ResKey.PLACEHOLDER_ABOUT_TEXT,
    Regex("TEMPLATE\\d+_WHY\\d+_DESC") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE\\d+_LOGO_SUBTITLE") to ResKey.PLACEHOLDER_EMPTY,
    Regex("TEMPLATE10_SERVICE\\d+_TIME") to ResKey.PLACEHOLDER_SERVICE_TIME,
    Regex("TEMPLATE10_INFO_TITLE\\d") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE10_INFO_DESC\\d") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE10_ABOUT_TITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE10_ABOUT_PARAGRAPH\\d") to ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT2,
    Regex("TEMPLATE10_VIDEOS_DESC") to ResKey.PLACEHOLDER_VALUES,
    Regex("TEMPLATE10_CONTACT_TITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE10_CONTACT_CARD_TITLE") to ResKey.PLACEHOLDER_ABOUT_TITLE,
    Regex("TEMPLATE10_CONTACT_CARD_TEXT") to ResKey.PLACEHOLDER_VALUES,

)

enum class UiMode(val value:String) {
    NORMAL("N"),
    PLACEHOLDER("P")
}

fun UiMode?.isContentSelected():Boolean?{
    return if(this==null) null
    else this==UiMode.NORMAL
}